export enum RouteLegWageType {
  FromTo = 0,
  ShuttleDistance = 1,
  MilesLessEqual = 2,
  //MilesGreaterEqual =3
  ShuttleDestination = 4,
  ShuttleDifDestination = 5
}

export const RouteLegWageTypeMapping: Record<RouteLegWageType, string> = {
  [RouteLegWageType.FromTo]: 'From => To',
  [RouteLegWageType.ShuttleDistance]: 'Shuttle (A=>B=>A) Miles Based',
  [RouteLegWageType.MilesLessEqual]: 'Miles <=',
  //[RouteLegWageType.MilesGreaterEqual]: 'Miles >='
  [RouteLegWageType.ShuttleDestination]: 'Shuttle (A=>B=>A) Dest. Based',
  [RouteLegWageType.ShuttleDifDestination]: 'Shuttle (A=>B=>C) Dest. Based'
};
